import { BookingWizardTab, SidebarStatus, VisibilityStatus } from '../../BookingWizard';
import { BookingWizardTabNames } from '../../BookingWizardConstants';
import { BookingWizardData } from '../../BookingWizardData/BaseBookingWizardData';
import { getDisableLinkForMultiFreight } from '../../ProgressBar/Utils/getDisableLinkForMultiFreight';
import BulkTicketsCriteriaTab from './BulkTicketsCriteriaTab';
import BulkTicketsReviewTab from './BulkTicketsReviewTab';
import { validateBulkTicketsStep } from './BulkTicketsValidator';

export const getBulkTicketsSteps = (wizardData: BookingWizardData): BookingWizardTab[] => {
	if (!wizardData.isBulkBookingFlow) {
		return [];
	}

	return [
		{
			name: BookingWizardTabNames.FindTickets,
			displayName: 'Tickets',
			path: 'bulk-tickets',
			tabTitle: 'Bulk tickets',
			tabTitleEdit: 'Edit bulk tickets',
			visibility: wizardData.isBulkBookingFlow ? VisibilityStatus.VISIBLE : VisibilityStatus.EXCLUDED,
			sidebarStatus: SidebarStatus.FILTERS,
			validateStep: updateErrorState => validateBulkTicketsStep(wizardData, updateErrorState),
			component: <BulkTicketsCriteriaTab />,
			authorize: false,
			showTAndCsButton: false,
			isLinkDisabled: getDisableLinkForMultiFreight(wizardData),
			continueBtnText: 'Search',
		},
		{
			name: BookingWizardTabNames.ReviewTickets,
			displayName: 'Tickets',
			path: 'review-tickets',
			tabTitle: 'Bulk tickets',
			tabTitleEdit: 'Edit bulk tickets',
			visibility: wizardData.isBulkBookingFlow ? VisibilityStatus.HIDDEN : VisibilityStatus.EXCLUDED,
			sidebarStatus: SidebarStatus.FILTERS,
			validateStep: updateErrorState => {
				// Tickets is skipped when running the wizard in bulk booking mode. This means that we don't need to do
				// validation for this step
				return true;
			},
			component: <BulkTicketsReviewTab />,
			authorize: false,
			showTAndCsButton: false,
			isLinkDisabled: getDisableLinkForMultiFreight(wizardData),
			continueBtnProps: {
				// The review step clears tripIds when the server says the search is over the limit,
				// so an empty list covers both "nothing matched" and "too much did". Re-checking the
				// length against the local app config copy would only add a way for a stale
				// window.configData to block a search the server accepted.
				disabled: (wizardData.bulkBookingFilters?.tripIds ?? []).length === 0,
			},
		},
	];
};
